<label class="form-switch">
  <div class="switch-wrap bg-gray-light text-gray-dark flex items-center ">
    <span translate>{{ label }}</span>
    <input type="checkbox" (change)="change()" [checked]="value">
    <i></i>
  </div>
</label>
